import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QrCodeIcon from '@mui/icons-material/QrCode';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import WorkIcon from '@mui/icons-material/Work';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import QR from '../../images/AcadamyImages/RegistrationQR.jpg';
import { palette } from '../../styles/palette';

// Icons for Rules Section
import GavelIcon from '@mui/icons-material/Gavel';
import CodeIcon from '@mui/icons-material/Code';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import DataArrayIcon from '@mui/icons-material/DataArray';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import GradingIcon from '@mui/icons-material/Grading';
import WarningIcon from '@mui/icons-material/Warning';
import BusinessIcon from '@mui/icons-material/Business';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ComputerIcon from '@mui/icons-material/Computer';
import WifiIcon from '@mui/icons-material/Wifi';
import GroupIcon from '@mui/icons-material/Group';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PublicIcon from '@mui/icons-material/Public';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import EmailIcon from '@mui/icons-material/Email';
import VideocamIcon from '@mui/icons-material/Videocam';
import LinkIcon from '@mui/icons-material/Link';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { icon } from '@fortawesome/fontawesome-svg-core';
import QuizIcon from '@mui/icons-material/Quiz';

const HackathonAnnouncement = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <Box sx={{ py: 12 }}>
      <Card
        sx={{
          maxWidth: 700,
          margin: 'auto',
          p: 3,
          borderRadius: 3,
          boxShadow: 6,
          border: `2px solid ${palette.primary}`,
          backgroundColor: '#ffffff',
        }}
      >
        <CardContent>
          {/* Hackathon Details */}
          <Typography
            variant="h4"
            align="center"
            fontWeight="bold"
            color="#007bff"
            gutterBottom
          >
            MERN STACK DEVELOPERS HACKATHON 2025
          </Typography>
          <Typography variant="subtitle1" align="center" gutterBottom>
            Are you a budding MERN Stack developer ready to prove your skills?
          </Typography>
          <Typography
            variant="body1"
            align="center"
            sx={{ fontWeight: 'bold', mb: 2 }}
          >
            Don’t miss the Leapot Hackathon happening on <br />
            <span style={{ color: '#007bff' }}>
              <strong>May 24, 2025, from 10:00 AM to 7:00 PM!</strong>
            </span>
          </Typography>

          {/* Highlights */}
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={1.5}
            mb={2}
          >
            <EmojiEventsIcon sx={{ color: '#ff9900' }} />
            <Typography variant="body1">
              Exciting Prizes for the Winners
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={1.5}
            mb={3}
          >
            <WorkIcon sx={{ color: '#5c4033' }} />
            <Typography variant="body1">Paid Internship Opportunity</Typography>
          </Box>

          <Typography
            variant="body1"
            align="center"
            color="error"
            fontWeight="bold"
            mb={3}
          >
            🚨 Limited Spots Available – Register Soon!
          </Typography>

          {/* Eligibility */}
          <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            color="primary"
          >
            Eligibility Criteria:
          </Typography>
          <List dense>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Must have graduated after May 2024" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Must not be currently employed with any organization" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Should have a basic understanding of the MERN stack, GitHub, and a portfolio website" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <LaptopMacIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Must bring your own laptop" />
            </ListItem>
          </List>

          {/* Register Button */}
          <Box display="flex" justifyContent="center" mt={3} mb={2}>
            <Button
              variant="contained"
              size="large"
              startIcon={<QrCodeIcon />}
              href="https://docs.google.com/forms/d/e/1FAIpQLScIRuwZF-C1AnArJNGLi7_qvcspSKCprbBeANjhGlUv21sBKA/viewform"
              target="_blank"
              sx={{
                backgroundColor: '#007bff',
                '&:hover': { backgroundColor: '#0056b3' },
              }}
            >
              Click to Register
            </Button>
          </Box>

          {/* QR Image */}
          <Box
            display="flex"
            justifyContent="center"
            mb={2}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': { transform: 'scale(1.1)' },
            }}
          >
            <img
              src={QR}
              alt="Hackathon QR Code"
              style={{ width: 150, height: 150 }}
              onClick={() =>
                window.open(
                  'https://docs.google.com/forms/d/e/1FAIpQLScIRuwZF-C1AnArJNGLi7_qvcspSKCprbBeANjhGlUv21sBKA/viewform',
                )
              }
            />
          </Box>

          {/* Contact */}
          <Typography variant="body2" align="center" mt={3}>
            📧 Contact:{' '}
            <Link href="mailto:hr@leapot.in" underline="hover">
              hr@leapot.in
            </Link>
          </Typography>

          <Typography
            variant="subtitle1"
            align="center"
            mt={2}
            fontWeight="bold"
          >
            Take your first big leap in tech with Leapot!
          </Typography>

          {/* Rules Button */}
          <Box display="flex" justifyContent="center" mt={4}>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<GavelIcon />}
              onClick={() => setOpenModal(true)}
            >
              View Rules & Guidelines
            </Button>
          </Box>

          {/* Modal */}
          <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                Leapot Hackathon Rules and Guidelines
              </Typography>
              <IconButton onClick={() => setOpenModal(false)}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {/* General Rules */}
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                <CodeIcon
                  sx={{ mr: 1, verticalAlign: 'middle' }}
                  color="primary"
                />
                General Rules (Applicable to All Participants)
              </Typography>
              <List dense>
                {[
                  {
                    icon: <GroupIcon color="primary" />,
                    text: 'Team Size: The teams will be formed by the organizers and will consist of a maximum of two members.',
                  },
                  {
                    icon: <AccessTimeIcon color="primary" />,
                    text: 'The hackathon will run from 10:00 AM to 7:00 PM on Saturday, 24 May 2025. All final submissions must be made before 7:00 PM',
                  },
                  {
                    icon: <QuizIcon color="primary" />,
                    text: 'Problem Statement: Teams will receive the problem statement at the start of the hackathon.',
                  },
                  {
                    icon: <CodeOffIcon color="primary" />,
                    text: 'Original Work: All code and solutions must be developed during the hackathon hours only. Pre-written code or use of AI-generated full solutions is not allowed.',
                  },
                  {
                    icon: <DataArrayIcon color="primary" />,
                    text: 'Allowed Tools: You may use MERN stack technologies, APIs, and libraries available online.',
                  },
                  {
                    icon: <CloudUploadIcon color="primary" />,
                    text: 'Code Submission: Final code must be submitted to the provided GitHub repository or upload link before the deadline.',
                  },
                  {
                    icon: <GradingIcon color="primary" />,
                    text: 'Judging Criteria: Evaluation will be based on creativity, problem-solving approach, code quality, and functionality of the solution.',
                  },
                  {
                    icon: <WarningIcon color="primary" />,
                    text: 'Disqualification: Any form of plagiarism or rule violation will lead to immediate disqualification.',
                  },
                ].map((item, i) => (
                  <ListItem key={i}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItem>
                ))}
              </List>

              {/* Offline Rules */}
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                mt={3}
                gutterBottom
              >
                <BusinessIcon
                  sx={{ mr: 1, verticalAlign: 'middle' }}
                  color="primary"
                />
                Offline Participants (In-Person at Pune Office)
              </Typography>
              <List dense>
                {[
                  {
                    icon: <ScheduleIcon color="primary" />,
                    text: 'Arrive by 9:30 AM for registration and setup.',
                  },
                  {
                    icon: <ComputerIcon color="primary" />,
                    text: 'Bring your own laptop, charger, and accessories.',
                  },
                  {
                    icon: <WifiIcon color="primary" />,
                    text: 'Wi-Fi and power outlets provided.',
                  },
                  {
                    icon: <GroupIcon color="primary" />,
                    text: 'Professional and respectful behavior expected.',
                  },
                ].map((item, i) => (
                  <ListItem key={i}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItem>
                ))}
              </List>

              {/* Online Rules */}
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                mt={3}
                gutterBottom
              >
                <PublicIcon
                  sx={{ mr: 1, verticalAlign: 'middle' }}
                  color="primary"
                />
                Online Participants (Outside Pune)
              </Typography>
              <List dense>
                {[
                  {
                    icon: <LocationOffIcon color="primary" />,
                    text: 'Only participants outside Pune may participate online.',
                  },
                  {
                    icon: <NetworkCheckIcon color="primary" />,
                    text: 'Stable internet required throughout the day.',
                  },
                  {
                    icon: <EmailIcon color="primary" />,
                    text: 'Announcements and problem statements shared via Email/GMeet/Zoom.',
                  },
                  {
                    icon: <VideocamIcon color="primary" />,
                    text: 'Available for check-ins and Q&A sessions.',
                  },
                  {
                    icon: <LinkIcon color="primary" />,
                    text: 'Coordinate using video calls or tools like GMeet/Zoom.',
                  },
                ].map((item, i) => (
                  <ListItem key={i}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItem>
                ))}
              </List>
            </DialogContent>
          </Dialog>
        </CardContent>
      </Card>
    </Box>
  );
};

export default HackathonAnnouncement;
